import { Box, Spinner } from '@factorialco/deprecated-design-system'

export const LoadingState = () => (
  <Box alignItems="center" justifyContent="center" height="full" width="full">
    <Spinner />
  </Box>
)
